import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Cookies from 'js-cookie';
import { sendAnalyticsEvent } from '../utils/SendAnalyticsEvent';

function Header({ isHomepage }) {
    const [scrollPosition, setScrollPosition] = useState(0);
    const [auc, setAuc] = useState('');

    const handleScroll = () => {
        const position = window.scrollY;
        setScrollPosition(position);
    };

    useEffect(() => {
        setAuc(Cookies.get('UserAuthentication'));

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const sendEvent = () => {
        const eventProperties = {
            loginContext: "Discover page"
        };
        sendAnalyticsEvent("loginClick", eventProperties, "Purchase Journey", "Discover page");
    };

    return (
        <header className={`app-header ${scrollPosition > 0 ? "blur" : ""}`}>
            <Link to="/"><img src={process.env.PUBLIC_URL + "/images/iwanttfc-monochrome-logo.svg"} className="App-logo" alt="logo" /></Link>
            {
                (isHomepage || (!isHomepage && !auc)) &&
                <Link to="/select-plan" onClick={() => sendEvent()} className="login-button-cont"><span className="login-button">Login</span></Link>
            }

        </header>
    );
}

export default Header;